"use client"

import { Phone, Clock, DollarSign, Shield } from 'lucide-react'

interface ProcessCTASectionProps {
  cityName: string
}

export default function ProcessCTASection({ cityName }: ProcessCTASectionProps) {
  const handleGetGuide = () => {
    window.dispatchEvent(new CustomEvent('showQuoteModal'))
  }

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12">
            Why {cityName} Homebuyers Choose Manufactured Homes
          </h2>
          
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="bg-white rounded-xl p-8 text-center shadow-lg">
              <div className="w-16 h-16 bg-[#c88546] rounded-full flex items-center justify-center mx-auto mb-4">
                <Clock className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold mb-3">Move In Faster</h3>
              <p className="text-3xl font-bold text-[#c88546] mb-2">6-8 Months</p>
              <p className="text-gray-600">Complete installation vs 12-18 months for site-built homes</p>
            </div>
            
            <div className="bg-white rounded-xl p-8 text-center shadow-lg">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <DollarSign className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold mb-3">Save Money</h3>
              <p className="text-3xl font-bold text-green-600 mb-2">50-70% Less</p>
              <p className="text-gray-600">Than traditional construction in {cityName}</p>
            </div>
            
            <div className="bg-white rounded-xl p-8 text-center shadow-lg">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <Shield className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold mb-3">Quality Guaranteed</h3>
              <p className="text-3xl font-bold text-blue-600 mb-2">HUD Certified</p>
              <p className="text-gray-600">Built to strict federal standards with warranties</p>
            </div>
          </div>

          <div className="bg-gradient-to-r from-[#c88546] to-[#b87436] text-white rounded-xl p-8 text-center">
            <p className="text-2xl font-bold mb-4">
              Ready to Start Your {cityName} Home Journey?
            </p>
            <p className="text-lg mb-6">
              Join hundreds of satisfied homeowners who saved time and money with manufactured homes
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="tel:9283610298"
                className="bg-white text-[#c88546] px-8 py-3 rounded-lg hover:bg-gray-100 transition-colors font-semibold inline-flex items-center justify-center"
              >
                <Phone className="w-5 h-5 mr-2" />
                Call (928) 361-0298
              </a>
              <button
                onClick={handleGetGuide}
                className="bg-gray-900 text-white px-8 py-3 rounded-lg hover:bg-gray-800 transition-colors font-semibold"
              >
                Get Free Buyer's Guide
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}